import { useState, useEffect } from "react";
import AddStudyMaterial from "../AddStudyMaterialCM/AddStudyMaterial";
import "./SubjectDateailCM.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Pre_added from "./Pre_added";
import Homework_added from "./Homework_added";
import Activity_added from "./Activity_added";
import AssessmentAdded from "./AssessmentAdded";
import axios from "../../../../axios";
import DeleteLiveSession from "./PopUp/DeleteConfirmation";
import AttachmentLM from "./AttachmentLM";
import { ArrowBack } from "@mui/icons-material";
import { Typography, Stack, Box, Button } from "@mui/material";
import BBBLectureCard from "./bbblectureAdded";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import assets from "../../../../assets/assets";
import { Link } from "lucide-react";
import AddLinkPopup from "./AddLinkPopup";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function SubjectDateailCM({ standardId, sectionID }) {
  const [data, setData] = useState();
  const [standard, setStandard] = useState();
  const [section, setSection] = useState();
  //Added this state by Kuldeep
  const { state } = useLocation();
  //Remove disable add supplement button
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // useEffect(() => {
  //   const checkIfButtonShouldBeDisabled = () => {
  //     if (data?.date && data?.end_time) {
  //       // Parse the input date (dd mm yyyy)
  //       const [year, month, day] = data?.date?.split("-");
  //       const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
  //         2,
  //         "0"
  //       )}`;

  //       // Parse the input time (HHMM)
  //       const hours = data?.end_time?.slice(0, 2);
  //       const minutes = data?.end_time?.slice(2);

  //       // Create a new Date object
  //       const combinedDateTime = new Date(
  //         `${formattedDate}T${hours}:${minutes}:00`
  //       );

  //       // Get the current date and time
  //       const now = new Date();

  //       // Disable the button if the current date and time is ahead of the combined date and time
  //       setIsButtonDisabled(now > combinedDateTime);
  //     }
  //   };

  //   checkIfButtonShouldBeDisabled();
  // }, [data]);

  useEffect(() => {
    let res = JSON.parse(localStorage.getItem("liveSession"));
    let res1 = JSON.parse(localStorage.getItem("std"));
    setData(res);
    setStandard(res1?.standardName);
    setSection(res1?.sectionName);
  }, []);

  const handleRefreshData = async () => {
    try {
      await supplementDataHandle();

      toast.success("Data refreshed successfully");
    } catch (error) {
      console.log(error);
      toast.error("Failed to refresh");
    }
  };

  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json_id = JSON.parse(Teacher_id);

  const [click, setClick] = useState({
    addMaterial: state?.addMaterial ? true : false,
  });
  const [supplement, setSupplement] = useState();
  const [description, setDescription] = useState();
  const [lecInstruction, setLecInstruction] = useState();
  const [lecInstructionCopy, setLecInstructionCopy] = useState();
  const [descriptionCopy, setDescriptionCopy] = useState();
  const [showIcons, setShowIcons] = useState(false);
  const [showIconsInsDesc, setShowIconsInsDesc] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [supplementData, setSupplementData] = useState({});
  const [attachMent, setAttachment] = useState([]);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [loader, setLoader] = useState(false);
  const [errorsize, setErrorSize] = useState(false);
  const [attach, setAttach] = useState([]);
  const [attachmentSize, setAttachmentSize] = useState([]); // Stores file names
  const [isDeliveredLecture, setIsDeliveredLecture] = useState(false); // Stores file names
  const [supplementIds, setSupplementIds] = useState("");
  const [reRenderPage, setReRenderPage] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [showLinkBox, setShowLinkBox] = useState(false);
  const [linkValue, setLinkValue] = useState("");

  const navigate = useNavigate();
  const endDate = new Date(data?.EndTime);
  const today = new Date();

  // Normalize both dates to midnight (remove time)
  endDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const isFutureDate = endDate > today;

  const handleSupplementData = (data) => {
    setSupplementData(data);
  };
  const supplementDataHandle = async (idFromResponse) => {
    if (
      idFromResponse ||
      supplementIds !== "" ||
      state?.supplement_id !== undefined
    ) {
      try {
        let res = await axios.get(
          `api/v1/cm/liveSession/getSupplementById?supplement_id=${
            idFromResponse || supplementIds || state?.supplement_id
          }`,
        );
        console.log("res", res.data.data);
        setSupplement(res.data.data);
        setDescription(res.data.data.description || description);
        setLecInstruction(res.data.data.lecInstruction || lecInstruction);
        setLecInstructionCopy(res.data.data.lecInstruction);
        setDescriptionCopy(res.data.data.description);
        setAttach(res?.data?.data.attachments);
        // setAttachmentSize(res?.data?.data.attachments_sizeKb)
        setAttachmentSize(res?.data?.data.attachments_sizeKb);
        setIsDeliveredLecture(res.data.data.isLectureCompleted);
      } catch (error) {
        console.log(error?.message);
        // toast.warning(error.response.data.message)
      }
    }
  };

  //Re-render get supplement function
  useEffect(() => {
    supplementDataHandle();
  }, [reRenderPage]);

  const previousLectureDate = () => {
    const currentDate = new Date();
    const enddDate = new Date(state.end_date);
    return enddDate < currentDate;
  };

  function convertTo12HourFormat(timeString) {
    const hour = parseInt(timeString?.slice(0, 2));
    const minute = parseInt(timeString?.slice(2));
    const isPM = hour >= 12;
    const twelveHourFormatHour = hour % 12 || 12;
    const formattedTime = `${twelveHourFormatHour}:${minute
      .toString()
      .padStart(2, "0")} ${isPM ? "pm" : "am"}`;
    return formattedTime;
  }
  function formatTime(inputDate) {
    const date = new Date(inputDate);
    let hour = date.getHours();
    const minute = date.getMinutes();
    const isPM = hour >= 12;
    if (hour > 12) {
      hour -= 12;
    } else if (hour === 0) {
      hour = 12;
    }
    const twelveHourFormatHour = hour < 10 ? `0${hour}` : `${hour}`;
    const formattedTime = `${twelveHourFormatHour}:${minute
      .toString()
      .padStart(2, "0")} ${isPM ? "pm" : "am"}`;

    return formattedTime;
  }
  const handleSupplementCount = (supplements) => {
    // if (!supplements || typeof supplements !== "object") {
    //   console.error("Invalid supplements:", supplements);
    //   return 0;
    // }
    let count = 0;
    for (const key in supplements) {
      if (
        // key !== "bbb_lecture" &&
        key !== "id" &&
        key !== "schedule_date" &&
        key !== "description" &&
        key !== "lecture_id" &&
        key !== "lecInstruction" &&
        supplements[key] &&
        supplements[key] !== null &&
        key !== "isLectureCompleted" &&
        key !== "attachments" &&
        key !== "attachments_sizeKb"
      ) {
        count++;
      }
    }
    return count;
  };

  const dateHelper = (a) => {
    //Add logic for get date formate
    const newDate = new Date(a);
    if (newDate == "Invalid Date") {
      let date = a.split(" ");
      date = date[1];
      date = date.replace("(", "").replace(")", "");
      date = date.split("/");

      const [day, month, year] = date;
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    }
    const month = newDate.getMonth() + 1;
    const day = newDate.getDate();
    const year = newDate.getFullYear();

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const handleUpdateDescription = async () => {
    let payload = {
      lecInstruction: lecInstruction,
      description: description,
    };
    try {
      if (state?.supplement_id !== undefined) {
        let res = await axios.post(
          `/api/v1/cm/liveSession/updateDescription?supplement_id=${state?.supplement_id}`,
          payload,
        );
        if (res) {
          setSupplementIds(res.data.data.id);
          supplementDataHandle(res.data.data.id);
        }
        if (payload.lecInstruction && !payload.description) {
          toast.success("Lecture Instruction Updated Successfully");
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else if (!payload.lecInstruction && payload.description) {
          toast.success("Lecture Summary Updated Successfully");
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else if (payload.lecInstruction && payload.description) {
          toast.success(
            "Lecture Instruction and Lecture Summary Both Updated Successfully",
          );
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else {
          toast.success(
            "Lecture Instruction and Lecture Summary are required!",
          );
          setShowIcons(false);
          setShowIconsInsDesc(false);
        }
      } else {
        let res = await axios.post(
          `/api/v1/cm/liveSession/addSupplements?lecture_id=${
            state.lecture_id
          }&schedule_date=${dateHelper(state.scheduled_date)}`,
          payload,
        );
        if (res) {
          setSupplementIds(res.data.data.id);
          supplementDataHandle(res.data.data.id);
        }
        if (payload.lecInstruction && !payload.description) {
          toast.success("Lecture Instruction Updated Successfully");
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else if (!payload.lecInstruction && payload.description) {
          toast.success("Lecture Summary Updated Successfully");
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else if (payload.lecInstruction && payload.description) {
          toast.success(
            "Lecture Instruction and Lecture Summary Both Updated Successfully",
          );
          setShowIcons(false);
          setShowIconsInsDesc(false);
        } else {
          toast.success(
            "Lecture Instruction and Lecture Summary are required!",
          );
          setShowIcons(false);
          setShowIconsInsDesc(false);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };
  function isDateLessThanCurrent(dateString) {
    const passedDate = new Date(dateString);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return passedDate < currentDate;
  }
  function formatDate(inputDateStr) {
    if (inputDateStr !== undefined) {
      const dateParts = inputDateStr.split("-");
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];
      const formattedDate = `${day}/${month}/${year}`;
      return formattedDate;
    }
  }
  function formatDate1(inputDate) {
    const date = new Date(inputDate);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad the day and month with leading zeroes if needed
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    const formattedMonth = month < 10 ? `0${month}` : `${month}`;

    return `${formattedDay}/${formattedMonth}/${year}`;
  }
  // Here I added new fields for Lecture Summary
  const [inputValueDesc, setInputValueDesc] = useState("");
  const [inputValueInsDesc, setInputValueInsDesc] = useState("");
  const maxCharacterCountDesc = 2000;
  const maxCharacterCountInsDesc = 500;

  const handleSelectChange = async (e) => {
    const selectValue = e.target.value === "true";
    // setSelectedOption(selectValue)
    let payload = {
      isLectureCompleted: selectValue,
    };
    try {
      let res = await axios.post(
        `/api/v1/cm/liveSession/addSupplements?lecture_id=${
          state.lecture_id
        }&schedule_date=${dateHelper(state.scheduled_date)}`,
        payload,
      );
      if (res) {
        setSupplementIds(res.data.data.id);
        supplementDataHandle(res.data.data.id);
        toast.success("Lecture Delivered Successfully");
      } else {
        toast.error("Lecture Failed to Delivered!");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleAddMaterial = () => {
    // if (previousLectureDate()) {
    //   toast.error("Lecture session already completed!!");
    //   return;
    // }
    setClick({
      ...click,
      addMaterial: true,
    });
  };

  const handleAttach = async (id, e) => {
    e.stopPropagation();
    const hasHttps = attach.some((item) => item.startsWith("https://"));
    if (hasHttps) {
      const newArray = [...attach];
      const newArrayFiltered = newArray.filter((_, index) => index !== id);

      setAttach(newArrayFiltered);

      let updatedAttachments = {
        attachments: newArrayFiltered,
        attachments_sizeKb: [],
      };
      setLoader(true);
      try {
        let res = await axios.post(
          `/api/v1/cm/liveSession/addSupplements?lecture_id=${
            state.lecture_id
          }&schedule_date=${dateHelper(state.scheduled_date)}`,
          updatedAttachments,
        );
        if (res) {
          setLoader(false);
          supplementDataHandle(res.data.data.id);
          setAttachmentSize(res.data?.data?.attachments_sizeKb);
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoader(false);
      }
    } else {
      const newArray = [...attach];
      const newArrayAttachSize_Kb = [...attachmentSize];
      let attachPath = newArray.splice(id, 1);
      newArrayAttachSize_Kb.splice(id, 1);
      try {
        setLoader(true);
        let res = await axios.delete(`/api/v1/file/delete`, {
          data: { file_path: attachPath[0] },
        });
        let updatedAttachments = {
          attachments: newArray,
          attachments_sizeKb: newArrayAttachSize_Kb,
        };
        try {
          let res = await axios.post(
            `/api/v1/cm/liveSession/addSupplements?lecture_id=${
              state.lecture_id
            }&schedule_date=${dateHelper(state.scheduled_date)}`,
            updatedAttachments,
          );
          if (res) {
            setLoader(false);
            supplementDataHandle(res.data.data.id);
            setAttachmentSize(res.data?.data?.attachments_sizeKb);
          }
        } catch (error) {
          console.log("error", error);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader(false);
      }
    }
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;
    if (!allowedExtensions.exec(filePath.name) || attach.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // let totalSize = attachMent.reduce((acc, file) => acc + file.size, 0);

    // Check if the file is already uploaded
    // const isFileAlreadyUploaded = attachMent.some(
    //   (uploadedFile) =>
    //     uploadedFile.name === file.name && uploadedFile.size === file.size
    // );

    // if (isFileAlreadyUploaded) {
    //   toast.warning("File already uploaded");
    //   setIsValidFileType(false);
    //   return;
    // }

    if (file.size <= 25 * 1024 * 1024 && validateFileType(file)) {
      const formData = new FormData();
      let fileType = file?.type;
      let fileSize = file?.size;

      setLoader(true);
      formData.append("uploadLectureAttachment", file);
      if (fileSize > 25 * 1024 * 1024) {
        setErrorSize(true);
      } else {
        setErrorSize(false);
        axios
          .post(
            `/api/v1/cm/liveSession/uploadAttachment/teacherId/${Teacher_Json_id}`,
            formData,
          )
          .then((response) => {
            let currectAttachment = [];
            setAttachment((prev) => {
              currectAttachment = [...prev, file];
              return currectAttachment;
            });
            setAttach((prev) => {
              const updatedAttach = [...prev, response?.data?.data];

              uploadFiles(updatedAttach, file.size);
              return updatedAttach;
            });
            response && setLoader(false);
          })
          .catch((error) => {
            setLoader(false);
            console.error("Error uploading file:", error);
          });
      }
    } else {
      setIsValidFileType(false);
    }
  };

  const uploadFiles = async (updatedAttach, fileSize) => {
    let attachments = {
      attachments: updatedAttach,
      attachments_sizeKb: [
        ...(attachmentSize || []),
        Math.round(fileSize / 1024),
      ],
    };
    setLoader(true);
    try {
      let res = await axios.post(
        `/api/v1/cm/liveSession/addSupplements?lecture_id=${
          state.lecture_id
        }&schedule_date=${dateHelper(state.scheduled_date)}`,
        attachments,
      );
      if (res) {
        supplementDataHandle(res.data.data.id);
        setLoader(false);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (
      state?.buttonfunction === "Assessment" ||
      state?.buttonfunction === "Homework" ||
      state?.buttonfunction === "preRead" ||
      state?.buttonfunction === "Activity"
    ) {
      setClick({
        addMaterial: true,
      });
    }
  }, [state?.buttonfunction]);

  async function handleTakePhoto(dataUri) {
    const now = new Date();

    // Format date parts
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `capture-${day}-${month}-${year}-${hours}:${minutes}:${seconds}.${fileExtension}`;
    console.log("filename", filename);

    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });

      if (
        fileWithProperExtension.size <= 25 * 1024 * 1024 &&
        validateFileType(fileWithProperExtension)
      ) {
        console.log("fileWithProperExtension", fileWithProperExtension);
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadLectureAttachment", fileWithProperExtension);
        // formData.append("image", blob, `${new Date().getTime()}.jpg`); // Provide a filename
        console.log("formData", formData);

        let response = await axios.post(
          `/api/v1/cm/liveSession/uploadAttachment/teacherId/${Teacher_Json_id}`,
          formData,
        );

        if (response) {
          let currectAttachment = [];
          setAttachment((prev) => {
            currectAttachment = [...prev, fileWithProperExtension];
            return currectAttachment;
          });
          setAttach((prev) => {
            const updatedAttach = [...prev, response?.data?.data];
            uploadFiles(updatedAttach, fileWithProperExtension.size);
            return updatedAttach;
          });
          response && setLoader(false);
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    } finally {
      setIsCameraOpen(false);
    }
  }

  const handleCameraError = (error) => {
    console.error("Camera error:", error);
    alert("Unable to access the camera. Please check your device settings.");
  };

  const onChangeLinkValue = (value) => {
    setLinkValue(value);
  };

  const handleSaveLink = () => {
    if (linkValue.trim() === "" || !linkValue.startsWith("https://")) {
      toast.error("Please enter a valid link.");
      return;
    }

    setAttach((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      const updatedLinks = [...safePrev, linkValue];
      uploadFiles(updatedLinks, 0);
      return updatedLinks;
    });
    setLinkValue("");
    setShowLinkBox(false);
  };

  return (
    <div
      className="orange-scrollBar"
      style={{ maxHeight: "calc(100vh - 100px)", overflowY: "scroll" }}
    >
      <div className="col-12 p-0 d-flex flex-wrap mt-1 subjctDetailContainer">
        <div className="col-md-8">
          <div className="Class_CM">
            <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
              <ArrowBack />{" "}
              {`${state?.standardsName || ""} - ${state?.sectionName || ""}`}
            </div>
            <div className="SelectBox_LM d-flex align-items-center gap-2">
              <span style={{ whiteSpace: "nowrap" }}>Lecture Delivered</span>

              <select
                className="SelectBoxOption"
                onChange={handleSelectChange}
                value={isDeliveredLecture}
                disabled={isFutureDate}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>

              <Button
                variant="outlined"
                size="small"
                onClick={handleRefreshData}
                sx={{
                  minWidth: "36px",
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  p: 0,
                }}
              >
                <RefreshIcon fontSize="small" />
              </Button>
            </div>
          </div>

          <div className="subject_CM mt-2">
            {data?.name || data?.LectureName}
          </div>
          <div className="time_CM mt-1">
            {formatDate(data?.date) || formatDate1(data?.StartTime)} |{" "}
            {data?.start_time
              ? convertTo12HourFormat(data?.start_time)
              : formatTime(data?.StartTime)}
          </div>
          <div className="Class_CM mt-2">Lecture Instruction</div>
          <div>
            <textarea
              className="col-12 instruction_IP_CM mt-2"
              maxLength={500}
              rows="2"
              readOnly={isDateLessThanCurrent(data?.date)}
              value={lecInstruction}
              onChange={(e) => {
                const newValue = e.target.value;
                if (newValue.length <= maxCharacterCountInsDesc) {
                  setLecInstruction(newValue);
                  // setInputValueInsDesc(newValue);
                  setShowIconsInsDesc(true);
                }
              }}
            />
          </div>
          <div className="d-flex justify-content-end position-relative gap-2">
            {showIconsInsDesc && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1,
                }}
              >
                {/* DONE BUTTON */}
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={handleUpdateDescription}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "8px",
                    px: 2,
                    py: 0.5,
                    boxShadow: "0px 2px 8px rgba(0, 128, 0, 0.25)",
                  }}
                >
                  ✓ Done
                </Button>

                {/* DISCARD BUTTON */}
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    lecInstructionCopy === undefined
                      ? setLecInstruction("")
                      : setLecInstruction(lecInstructionCopy);
                    setShowIconsInsDesc(false);
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "8px",
                    px: 2,
                    py: 0.5,
                    boxShadow: "0px 2px 8px rgba(255, 0, 0, 0.25)",
                  }}
                >
                  ✕ Discard
                </Button>
              </Box>
            )}

            <div className="d-flex justify-content-end ">
              {lecInstruction?.length}/{maxCharacterCountInsDesc}
            </div>
          </div>
          {/* Lecture Summary */}
          <div className="Class_CM mt-1">Lecture Summary</div>
          <div>
            <textarea
              className="col-12 instruction_IP_CM mt-2 p-2"
              maxLength={2000}
              rows="3"
              readOnly={isDateLessThanCurrent(data?.date)}
              value={description}
              onChange={(e) => {
                const newValue = e.target.value;
                if (newValue.length <= maxCharacterCountDesc) {
                  setDescription(newValue);
                  // setInputValueDesc(newValue);
                  setShowIcons(true);
                }
              }}
            />
          </div>
          <div className="d-flex justify-content-end position-relative gap-2">
            <div>
              {showIcons && (
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
                >
                  {/* DONE BUTTON */}
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={handleUpdateDescription}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      boxShadow: "0px 2px 8px rgba(0, 128, 0, 0.25)",
                    }}
                  >
                    ✓ Done
                  </Button>

                  {/* DISCARD BUTTON */}
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => {
                      descriptionCopy === undefined
                        ? setDescription("")
                        : setDescription(descriptionCopy);
                      setShowIcons(false);
                    }}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      boxShadow: "0px 2px 8px rgba(255, 0, 0, 0.25)",
                    }}
                  >
                    ✕ Discard
                  </Button>
                </Box>
              )}
            </div>
            <div className="d-flex justify-content-end">
              {description?.length}/{maxCharacterCountDesc}
            </div>
          </div>
          <div className="main_attach_box">
            <div className="attachment_LM position-relative">
              <div className="sharedText">Shared Files</div>
              <div clsassName="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  {/* Add Link */}
                  <div
                    className="cameraContainerActivity gap-2"
                    onClick={() => setShowLinkBox(!showLinkBox)}
                    style={{ cursor: "pointer" }}
                  >
                    <Link size={20} />
                    <span className="uploadHereText p-1">Add Link</span>
                  </div>
                  {/* File Upload */}
                  <div clsassName="d-flex align-items-center">
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      id="attachFile"
                      style={{ display: "none" }}
                      onInput={(e) => {
                        handleFileChange(e);
                        e.target.value = null;
                      }}
                    />
                    <label
                      className="cameraContainerAddAttachment"
                      htmlFor="attachFile"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={assets.UploadIcon}
                        alt=""
                        style={{ width: "28px" }}
                      />
                      <span className="uploadHereText">&nbsp;Upload files</span>
                    </label>
                  </div>

                  {/* Camera Upload */}
                  {!isCameraOpen ? (
                    <div
                      onClick={() => setIsCameraOpen(true)}
                      className="d-flex align-items-center gap-2 cameraContainerActivity"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/images/CameranewIcon.png"
                        alt=""
                        style={{ width: "33px" }}
                      />
                      <span className="uploadHereText">Take Photo</span>
                    </div>
                  ) : (
                    <div className="opended_camera">
                      <img
                        onClick={() => setIsCameraOpen(!isCameraOpen)}
                        className="cross_icon"
                        src={assets.closeIcon}
                        alt="cross logo"
                      />
                      <Camera
                        onTakePhoto={handleTakePhoto}
                        idealFacingMode="environment"
                        isImageMirror={false}
                        imageCompression={0.97}
                        isMaxResolution={true}
                        isSilentMode={false}
                        className="custom-camera"
                        onCameraError={handleCameraError}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <div>
                {loader && (
                  <img
                    style={{ width: "32px", height: "32px" }}
                    src="/gif/Loader.gif"
                  />
                )}
              </div>
              <div>
                {errorsize && (
                  <p className="error_msg">
                    Kindly upload file less than 10MB.
                  </p>
                )}
              </div>
            </div>
            <div className="preread_attachment">
              {attach &&
                attach.map((obj, index) => (
                  <AttachmentLM
                    attach={obj}
                    id={index}
                    fileSize={attachmentSize[index]}
                    handleAttach={handleAttach}
                    lecture_id={state.lecture_id}
                    scheduled_date={state.scheduled_date}
                    dateHelper={dateHelper}
                    supplementDataHandle={supplementDataHandle}
                    linkValue={linkValue}
                  />
                ))}
            </div>
          </div>
          {!isValidFileType && (
            <p id="errorMsg">
              Please upload files with valid extensions (pdf, jpg, jpeg, png,
              pptx, ppt, mp3, mp4). The maximum upload limit is 5 files, and the
              total size should not exceed 25MB. And you cannot upload same file
              more than once.
            </p>
          )}
        </div>

        <div className="col-md-4 ">
          {/* <div className="d-flex align-items-center justify-content-between">
            <span className="Class_CM">
              Added Lecture Supplement ({handleSupplementCount(supplement)})
            </span>
            <button
              className="gap-2 add_materialbtn_CM"
              onClick={(e) =>
                setClick({
                  ...click,
                  addMaterial: true,
                })
              }
            >
              <img src="/ContentM_images/add icon.svg" alt="add logo" />
              <span>Add Lecture Supplement</span>
            </button>
          </div> */}

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              mb: 2,
              px: 1,
            }}
          >
            {/* Left Text */}
            <Typography
              variant="subtitle1"
              fontWeight={600}
              color="text.primary"
              sx={{ fontSize: "1rem" }}
            >
              Added Lecture Supplement{" "}
              <Typography
                component="span"
                variant="subtitle1"
                fontWeight={700}
                color="primary.main"
              >
                ({handleSupplementCount(supplement)})
              </Typography>
            </Typography>

            {/* Right Button */}
            <button
              className="gap-2 add_materialbtn_CM px-2 py-2"
              onClick={handleAddMaterial}
            >
              <img src="/ContentM_images/add icon.svg" alt="add logo" />
              <span>Add Lecture Supplement</span>
            </button>
          </Stack>

          <div className="added_cm_container">
            {supplement?.preRead !== null && supplement !== undefined && (
              <div className="mt-2 ms-3 d-flex flex-wrap gap-3 added_cm_sub_container">
                <Pre_added
                  data={supplement?.preRead}
                  supplement={state?.supplement_id}
                  setDeleteConfirm={setDeleteConfirm}
                  send={handleSupplementData}
                  date={data?.EndTime}
                  standard={state?.standardsName}
                  section={state?.sectionName}
                />
              </div>
            )}
            {supplement?.activity !== null && supplement !== undefined && (
              <div className="mt-1 ms-3  d-flex flex-wrap gap-3 added_cm_sub_container">
                <Activity_added
                  data={supplement?.activity}
                  supplement={state?.supplement_id}
                  setDeleteConfirm={setDeleteConfirm}
                  send={handleSupplementData}
                  date={data?.EndTime}
                  standard={state?.standardsName}
                  section={state?.sectionName}
                />
              </div>
            )}
            {supplement?.homework !== null && supplement !== undefined && (
              <div className="mt-1 ms-3  d-flex flex-wrap gap-3 added_cm_sub_container">
                <Homework_added
                  data={supplement?.homework}
                  supplement={state?.supplement_id}
                  setDeleteConfirm={setDeleteConfirm}
                  send={handleSupplementData}
                  date={data?.EndTime}
                />
              </div>
            )}
            {supplement?.assessment !== null && supplement !== undefined && (
              <div className="mt-1 ms-3  d-flex flex-wrap gap-3 added_cm_sub_container">
                <AssessmentAdded
                  data={supplement?.assessment}
                  supplement={state?.supplement_id}
                  setDeleteConfirm={setDeleteConfirm}
                  send={handleSupplementData}
                  date={data?.EndTime}
                />
              </div>
            )}
            {supplement?.bbbLecture !== null && supplement !== undefined && (
              <div className="mt-1 ms-3 p-1 d-flex flex-wrap gap-3 added_cm_sub_container">
                <BBBLectureCard
                  data={supplement?.bbbLecture}
                  supplement={state?.supplement_id}
                  send={handleSupplementData}
                  supplementData={supplement}
                  setDeleteConfirm={setDeleteConfirm}
                  date={data?.EndTime}
                />
              </div>
            )}
          </div>
        </div>

        {/* <div className="col-md-4 ">
        <span className="upcominClass">Upcoming Classes</span>
        <div className="mt-3 p-1 upcoming_class_container_cm ">
          {upcomingClass?.length > 0 ? (
            upcomingClass?.map((obj) => (
              <SubjectCM data={obj} standard={standard} section={section} />
            ))
          ) : (
            <>
              <div className="d-flex gap-2 align-items-center noClass">
                No more classes for today.
              </div>
            </>
          )}
        </div>
      </div> */}
        {deleteConfirm && (
          <DeleteLiveSession
            setDeleteConfirm={setDeleteConfirm}
            data={supplementData}
            supplementDataHandle={supplementDataHandle}
          />
        )}
        {click?.addMaterial && (
          <AddStudyMaterial
            setClick={setClick}
            data={data}
            standardId={state?.standard_id}
            sectionId={state?.section_id}
            supplementId={state?.supplement_id}
            redirectState={{
              ...state,
              supplement_id: state?.supplement_id || supplementIds,
            }}
            seletedType={state?.buttonfunction}
            supplementDataHandle={supplementDataHandle}
            setReRenderPage={setReRenderPage}
            supplement={supplement}
          />
        )}
        {showLinkBox && (
          <AddLinkPopup
            setShowLinkBox={setShowLinkBox}
            onChangeLinkValue={onChangeLinkValue}
            linkValue={linkValue}
            handleSaveLink={handleSaveLink}
          />
        )}
      </div>
    </div>
  );
}
